const showcase = document.getElementById('showcase') as HTMLIFrameElement;
const key = 'zmdnmy5g1nsxiqep6eymyg62d';

// declare this file is a module
export {};

// augment window with the MP_SDK property
declare global {
  interface Window {
    MP_SDK: any;
  }
}

showcase.addEventListener('load', async function() {
  let sdk;
  try {
    sdk = await showcase.contentWindow.MP_SDK.connect(showcase, key, '3.2');
  }
  catch(e) {
    console.error(e);
    return;
  }

  console.log('%c  Hello Bundle SDK! ', 'background: #333333; color: #00dd00');
  console.log(sdk);



const lights = await sdk.Scene.createNode();
lights.addComponent('mp.lights');
lights.start();

const modelNode = await sdk.Scene.createNode();
const modelNode2 = await sdk.Scene.createNode();
const modelNode3 = await sdk.Scene.createNode();
const modelNode4 = await sdk.Scene.createNode();
//const modelNode5 = await sdk.Scene.createNode();

// Store the fbx component since we will need to adjust it in the next step.
const fbxComponent = modelNode.addComponent(sdk.Scene.Component.GLTF_LOADER, {
  url: '/3d-kagu/demo9.glb',
});

// Store the fbx component since we will need to adjust it in the next step.
const fbxComponent2 = modelNode2.addComponent(sdk.Scene.Component.GLTF_LOADER, {
  url: '/3d-kagu/demo8.glb',
});

// Store the fbx component since we will need to adjust it in the next step.
const fbxComponent3 = modelNode3.addComponent(sdk.Scene.Component.GLTF_LOADER, {
  url: '/kahaku/kabe.glb',
});

// Store the fbx component since we will need to adjust it in the next step.
const fbxComponent4 = modelNode4.addComponent(sdk.Scene.Component.GLTF_LOADER, {
  url: '/kahaku/kabe.glb',
});
/*
// Store the fbx component since we will need to adjust it in the next step.
const fbxComponent5 = modelNode5.addComponent(sdk.Scene.Component.GLTF_LOADER, {
  url: '/3d-kagu/demo6.glb',
});*/
//ソファ
fbxComponent.inputs.localScale = {
  x: 1,
  y: 1,
  z: 1
};

//TV
fbxComponent2.inputs.localScale = {
  x: 1,
  y: 1,
  z: 1
};

//植木

fbxComponent3.inputs.localScale = {
  x: 1,
  y: 1,
  z: 1
};

//看板
fbxComponent4.inputs.localScale = {
  x: 1,
  y: 1,
  z: 1
};
/*
//絵
fbxComponent5.inputs.localScale = {
  x: 1.5,
  y: 0.51,
  z: 0.51
};
*/
modelNode.obj3D.position.set(0, 0, 1); // drop ~3 feet
modelNode2.obj3D.position.set(10,0, 2); // drop ~3 feet
modelNode3.obj3D.position.set(11,0,5.4); // drop ~3 feet
modelNode4.obj3D.position.set(6,0,8.7); // drop ~3 feet
/*modelNode5.obj3D.position.set(1.5,0.8,0.5); // 横、高、縦*/


modelNode.start();
modelNode2.start();
modelNode3.start();
modelNode4.start();
/*modelNode5.start();*/


const tick = function() {
  requestAnimationFrame(tick);
  modelNode.obj3D.rotation.y = 0;
  modelNode2.obj3D.rotation.y = 0;
  modelNode3.obj3D.rotation.y = 1.6;
  modelNode4.obj3D.rotation.y = 0;
  /*modelNode5.obj3D.rotation.y = -1.6;*/
}
tick();

});
